import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { process, State } from '@progress/kendo-data-query';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ContactMultiselectDialog } from '../contact/contact-email-popup.component';
import { CSEService } from '../../services/cse.service';
import { EmailService } from '../../services/email.service';
import { EncryptionService } from '../../services/encryption.service';
import { ERPService } from '../../services/erp.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    Email,
    SearchCarrierContact,
    SearchCarrierSalesUnverifiedLoads,
    SearchTagType
} from '../../models/models';

@Component({
    selector: 'carrier-sales-unverified-loads',
    templateUrl: './carrier-sales-unverified-loads.component.html',
    standalone: false
})
export class CarrierSalesUnverifiedLoads implements OnInit, OnChanges {
    @Input() loads: SearchCarrierSalesUnverifiedLoads[] = [];
    @Output() onClick = new EventEmitter<any>();
    @Output() onSave = new EventEmitter<any>();
    @ViewChild(GridComponent, { static: false }) public loadsGrid!: GridComponent;

    public isCSRManager: boolean = false;
    public filteredLoads: SearchCarrierSalesUnverifiedLoads[] = [];
    public contacts: SearchCarrierContact[] = [];
    public tagTypeList: SearchTagType[] = [];
    public isCarrierRepsAssigned: boolean = false;

    // Carrier Sales Reps Assigned dialog fields
    public quoteOrderLineID: number = 0;
    //public carrierDropReasonList: CarrierDropReason[] = [];

    public gridState: State = { skip: 0, take: 40, sort: [{ dir: 'asc', field: 'arrivalStartDate' }] };
    //public gridState: State = { sort: [{ dir: 'asc', field: 'arrivalStartDate' }] };
    public gridData: GridDataResult = { data: [], total: 0 };
    //public pageSizes: number[] = [5, 10, 20, 50, 100, 200, 500];

    constructor(public cseService: CSEService, public emailService: EmailService, public encryptionService: EncryptionService,
        public erpService: ERPService, private notificationService: NotificationService, private orderService: OrderService,
        private utilService: UtilService,
        public dialog: MatDialog, private ngZone: NgZone, private router: Router) { }

    ngOnInit() {
        this.orderService.getSearchTagTypes().subscribe(result => {
            this.tagTypeList = result.resultCollection;
        });
        this.isCSRManager = this.getIsCSRManager();
        this.updateLoads();
        //this.getCarrierDropReasons();
        //console.log("loads", this.loads.length);
        //this.getUnverifiedLoads();
    }

    ngOnChanges() {
        this.updateLoads();
        //this.getUnverifiedLoads();
    }

    private getIsCSRManager() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Carrier Sales Manager') > -1) return true;
        }

        return false;
    }

    //public getUnverifiedLoads() {
    //    this.utilService.isLoading = true;
    //    this.cseService.getSearchCarrierSalesUnverifiedLoads().subscribe(result => {
    //        this.utilService.isLoading = false;
    //        this.loads = result.resultCollection;
    //        this.loads.forEach(load => {
    //            if (load.arrivalStartDate != null) {
    //                load.arrivalStartDate = new Date(load.arrivalStartDate!);
    //            }
    //        });

    //        //this.filterUnverifiedLoads();
    //        this.updateLoads();
    //    });
    //}

    private updateLoads() {
        this.filteredLoads = Object.assign([], this.loads);
        this.filteredLoads = this.filteredLoads.filter(t => t.isExcludeVerification == false);
        this.gridData = process(this.filteredLoads, this.gridState);
        this.fitColumns();
        //console.log("updateLoads", this.filteredLoads);
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.loadsGrid == null) return;
            this.loadsGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        //this.updateLoads();
        this.gridData = process(this.loads, this.gridState);
        this.fitColumns();
    }

    public rowCallback(context: RowClassArgs) {
        const isHighPriority = (context.dataItem.orderPriority == "High");
        const isExpedite = (context.dataItem.rateIndex == "Expedite");
        if (isExpedite) {
            return {
                expedite: isExpedite
            }
        }
        else if (isHighPriority) {
            return {
                highPriority: isHighPriority
            }
        }
        else {
            return {}
        }
    }

    public editTender(load: SearchCarrierSalesUnverifiedLoads) {
        this.onClick.emit(load);
        //this.onOfferClick.emit(load.awardedOfferID);
    }

    public viewTracking(quoteOrderID: string) {
        this.encryptionService.getEncryptedValue(quoteOrderID).subscribe(result => {
            var encryptedQuoteOrderID = result;
            var relativeUrl = this.router.createUrlTree(['order-tracking', encryptedQuoteOrderID]);
            var baseUrl = window.location.href.replace(this.router.url, "");
            window.open(baseUrl + relativeUrl, "_blank");
            //this.router.navigate(['order-tracking', encryptedOrderNumber]);
        });
    }

    public linkMP(quoteOrderLineID: number) {
        console.log("linkMP", quoteOrderLineID);
        this.erpService.getMacropointLink(quoteOrderLineID).subscribe(result => {
            var url = result.resultCollection[0];
            if (url == "") {
                this.notificationService.showWarning("System failed to retrieve link from Macropoint. Please make sure this load is setup in their system.", "WARNING: Macropoint Link");
            }
            else {
                window.open(url, "_blank");
            }
        });
    }

    public excludeMP(load: SearchCarrierSalesUnverifiedLoads) {
        if (confirm("Exclude Macropoint?")) {
            load.isExcludeMacropoint = true;
            load.updatedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.utilService.isLoading = true;
            this.cseService.saveOfferFromSearchCarrierSalesUnverifiedLoads(load).subscribe(result => {
                this.utilService.isLoading = false;
                this.notificationService.showSuccess("Excluding Macropoint", "SUCCESS: Exclude Macropoint");
                //this.onSave.emit();
                //console.log("saveOfferFromSearchCarrierSalesBookedLoads", result);
            });
        }
    }

    public excludeVerification(load: SearchCarrierSalesUnverifiedLoads) {
        if (confirm("Exclude from verification?")) {
            load.isExcludeVerification = true;
            load.updatedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.utilService.isLoading = true;
            this.cseService.saveOfferFromSearchCarrierSalesUnverifiedLoads(load).subscribe(result => {
                this.utilService.isLoading = false;
                this.notificationService.showSuccess("Excluding from verification", "Success: Exclude Verification");
                //this.onSave.emit();
                this.updateLoads();
                //console.log("saveOfferFromSearchCarrierSalesBookedLoads", result);
            });
        }
    }

    public confirmCarrierPickup(load: SearchCarrierSalesUnverifiedLoads, isConfirmed: boolean) {
        load.isLoadVerified = isConfirmed;
        load.updatedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.utilService.isLoading = true;
        this.cseService.saveOfferFromSearchCarrierSalesUnverifiedLoads(load).subscribe(result => {
            this.utilService.isLoading = false;
            if (isConfirmed) {
                this.notificationService.showSuccess("Carrier pickup confirmed: Yes", "Success: Carrier Pickup Confirmed");
            }
            else {
                this.notificationService.showSuccess("Carrier pickup confirmed: No", "Success: Carrier Pickup Confirmed");
            }
            //this.onSave.emit();
            //console.log("saveOfferFromSearchCarrierSalesBookedLoads", result);
        });
    }

    public sendEmail(load: SearchCarrierSalesUnverifiedLoads) {
        console.log("sendEmail", load);
        var contacts: Email[] = [];
        var selectedContacts: Email[] = [];
        var typedEmails: string = "";
        var defaultContact: Email | undefined;

        for (var i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].email != null && this.contacts[i].email != "") {
                contacts.push({
                    email: this.contacts[i].email,
                    name: this.contacts[i].contactName
                });
            }
        }

        if (load.carrierContactEmail != null && load.carrierContactEmail != "") {
            defaultContact = {
                email: load.carrierContactEmail,
                name: load.carrierContactName
            }
        }

        typedEmails = "tracking@automatedlogistics.com";

        var fromEmail = localStorage.getItem('EpiEmail')!;
        if (fromEmail != null && fromEmail != "") {
            typedEmails = typedEmails + "," + fromEmail;
        }

        if (load.bookedByCarrierRepEmail != null && load.bookedByCarrierRepEmail != "") {
            typedEmails = typedEmails + "," + load.bookedByCarrierRepEmail;
        }

        //console.log("dialog.open", contacts, defaultContact, selectedContacts, typedEmails);

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            showNotes: true,
            contacts: contacts,
            defaultContact: defaultContact,
            selectedContacts: selectedContacts,
            typedEmails: typedEmails
        }

        const dialogRef = this.dialog.open(ContactMultiselectDialog, dialogConfig);

        //dialogRef.componentInstance.notes = dataItem.comment;

        dialogRef.afterClosed().subscribe(result => {
            //console.log("sendEmail:dialogRef.afterClosed()", result);
            if (result.btnOK == true) {
                if (defaultContact == undefined) {
                    if (selectedContacts.length > 0) {
                        defaultContact = selectedContacts[0];
                    }
                    else {
                        defaultContact = {
                            email: "",
                            name: ""
                        }
                    }
                }

                if (result == null ||
                    (
                        (defaultContact.email == null || defaultContact.email == "")
                        && (result.selectedContacts == null || result.selectedContacts.length < 1)
                        && (result.selectedEmails == null || result.selectedEmails.length < 1)
                    )
                ) return;

                var ccEmails = "";
                if (result.selectedContacts != null) {
                    result.selectedContacts.forEach(e => {
                        ccEmails += e.email + "|";
                    });
                }
                if (result.typedEmails && result.typedEmails.indexOf(",") >= 0) {
                    var typedEmails = result.typedEmails.split(",");
                    typedEmails.forEach(e => {
                        var email = e.trim();
                        if (ccEmails.indexOf(email) < 0) {
                            ccEmails += email + "|";
                        }
                    });
                }
                else {
                    ccEmails += result.typedEmails;
                }

                var subject = "Carrier award offer for order #" + load.orderNumber;

                this.utilService.isLoading = true;
                this.emailService.sendRateConfirmationCustom(load.quoteOrderLineID, defaultContact.email, ccEmails, "", -1, subject, result.notes).subscribe(emailResult => {
                    this.utilService.isLoading = false;
                    var ok = emailResult;
                    console.log("sendEmail Result", emailResult);
                });
            //this.emailService.sendEmail(defaultContact.email, emails, "", -1, subject, result.notes).subscribe(emailResult => {
            //    this.utilService.isLoading = false;
            //    var ok = emailResult;
            //    this.isSaving = false;
            //    this.onSaveClick.emit();
            //});
            }
        });
    }

    public getTagTypes(idList: string) {
        var tagTypes: SearchTagType[] = [];
        if (idList && idList != "") {
            var arr: number[] = [];
            arr = idList.replace(/, +/g, ",").split(",").map(Number);
            for (var i = 0; i < arr.length; i++) {
                var idx: number = this.tagTypeList.findIndex(t => t.tagTypeID == arr[i]);
                if (idx >= 0) {
                    tagTypes.push(this.tagTypeList[idx]);
                }
            }
        }
        return tagTypes;
    }
}
